import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
import { fetchChildData, fetchParentData } from "./MainMenu/FetchData";

export const getMainNavigationDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  mainMenu: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "name_malay",
      className: "col-span-6",
      type: "text",
      name: "name_malay",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "name_mandarin",
      className: "col-span-6",
      type: "text",
      name: "name_mandarin",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
    },

    {
      fieldName: "Redirect URL",
      fieldValue: "redirect_english",
      className: "col-span-6",
      type: "text",
      name: "redirect_english",
      formType: "inputNotes",
      label: "Redirect URL",
      placeholder: "Enter Redirect URL",
      validation: { required: "Redirect URL is required" },
      note: 'Click the info icon to learn more before entering a value.',
      uploadTrigger: true
    },
    // {
    //   fieldName: "Redirect URL (MS)",
    //   fieldValue: "redirect_malay",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "redirect_malay",
    //   formType: "input",
    //   label: "Redirect URL (MS)",
    //   placeholder: "Enter Redirect URL (MS)",
    // },
    // {
    //   fieldName: "Redirect URL (ZH)",
    //   fieldValue: "redirect_mandarin",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "redirect_mandarin",
    //   formType: "input",
    //   label: "Redirect URL (ZH)",
    //   placeholder: "Enter Redirect URL (ZH)",
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Is published",
    },
  ],
  aboutAndLegal: [
    {
      fieldName: "Copyright Text (EN)",
      fieldValue: "field_copyright_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_copyright_text_en",
      formType: "input",
      label: "Copyright Text (EN)",
      placeholder: "Enter Copyright Text (EN)",
      validation: { required: "Copyright Text (EN) is required" },
    },
    {
      fieldName: "Copyright Text (MS)",
      fieldValue: "field_copyright_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_copyright_text_ms",
      formType: "input",
      label: "Copyright Text (MS)",
      placeholder: "Enter Copyright Text (MS)",
      // validation: { required: "Copyright Text (MS) is required" },
    },
    {
      fieldName: "Copyright Text (ZH)",
      fieldValue: "field_copyright_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_copyright_text_zh",
      formType: "input",
      label: "Copyright Text (ZH)",
      placeholder: "Enter Copyright Text (ZH)",
      // validation: { required: "Copyright Text (ZH) is required" },
    },
    {
      fieldName: "Register Number Text (EN)",
      fieldValue: "field_registration_number_txt_en",
      className: "col-span-6",
      type: "text",
      name: "field_registration_number_txt_en",
      formType: "input",
      label: "Register Number Text (EN)",
      placeholder: "Enter Register Number Text (EN)",
      validation: { required: "Register Number Text (EN) is required" },
    },
    {
      fieldName: "Register Number Text (MS)",
      fieldValue: "field_registration_number_txt_ms",
      className: "col-span-6",
      type: "text",
      name: "field_registration_number_txt_ms",
      formType: "input",
      label: "Register Number Text (MS)",
      placeholder: "Enter Register Number Text (MS)",
      // validation: { required: "Register Number Text (MS) is required" },
    },
    {
      fieldName: "Register Number Text (ZH)",
      fieldValue: "field_registration_number_txt_zh",
      className: "col-span-6",
      type: "text",
      name: "field_registration_number_txt_zh",
      formType: "input",
      label: "Register Number Text (ZH)",
      placeholder: "Enter Register Number Text (ZH)",
      // validation: { required: "Register Number Text (ZH) is required" },
    },
    {
      fieldName: "Mobile App Text (EN)",
      fieldValue: "field_mobile_app_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_mobile_app_text_en",
      formType: "input",
      label: "Mobile App Text (EN)",
      placeholder: "Enter Mobile App Text (EN)",
      validation: { required: "Mobile App Text (EN) is required" },
    },
    {
      fieldName: "Mobile App Text (MS)",
      fieldValue: "field_mobile_app_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_mobile_app_text_ms",
      formType: "input",
      label: "Mobile App Text (MS)",
      placeholder: "Enter Mobile App Text (MS)",
      // validation: { required: "Mobile App Text (MS) is required" },
    },
    {
      fieldName: "Mobile App Text (ZH)",
      fieldValue: "field_mobile_app_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_mobile_app_text_zh",
      formType: "input",
      label: "Mobile App Text (ZH)",
      placeholder: "Enter Mobile App Text (ZH)",
      // validation: { required: "Mobile App Text (ZH) is required" },
    },
    {
      fieldName: "Terms of Use Text (EN)",
      fieldValue: "field_term_of_use_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_term_of_use_text_en",
      formType: "input",
      label: "Terms of Use Text (EN)",
      placeholder: "Enter Terms of Use Text (EN)",
      validation: { required: "Terms of Use Text (EN) is required" },
    },
    {
      fieldName: "Terms of Use Text (MS)",
      fieldValue: "field_term_of_use_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_term_of_use_text_ms",
      formType: "input",
      label: "Terms of Use Text (MS)",
      placeholder: "Enter Terms of Use Text (MS)",
      // validation: { required: "Terms of Use Text (MS) is required" },
    },
    {
      fieldName: "Terms of Use Text (ZH)",
      fieldValue: "field_term_of_use_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_term_of_use_text_zh",
      formType: "input",
      label: "Terms of Use Text (ZH)",
      placeholder: "Enter Terms of Use Text (ZH)",
      // validation: { required: "Terms of Use Text (ZH) is required" },
    },
    {
      fieldName: "Terms of Use Link",
      fieldValue: "termsOfUseLink",
      className: "col-span-6",
      type: "text",
      name: "termsOfUseLink",
      formType: "input",
      label: "Terms of Use Link",
      placeholder: "Enter Terms of Use Link",
      validation: { required: "Terms of Use Link is required" },
    },

    {
      fieldName: "Privacy Policy Text (EN)",
      fieldValue: "field_privacy_policy_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_privacy_policy_text_en",
      formType: "input",
      label: "Privacy Policy Text (EN)",
      placeholder: "Enter Privacy Policy Text (EN)",
      validation: { required: "Privacy Policy Text (EN) is required" },
    },
    {
      fieldName: "Privacy Policy Text (MS)",
      fieldValue: "field_privacy_policy_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_privacy_policy_text_ms",
      formType: "input",
      label: "Privacy Policy Text (MS)",
      placeholder: "Enter Privacy Policy Text (MS)",
      // validation: { required: "Privacy Policy Text (MS) is required" },
    },
    {
      fieldName: "Privacy Policy Text (ZH)",
      fieldValue: "field_privacy_policy_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_privacy_policy_text_zh",
      formType: "input",
      label: "Privacy Policy Text (ZH)",
      placeholder: "Enter Privacy Policy Text (ZH)",
      // validation: { required: "Privacy Policy Text (ZH) is required" },
    },
    {
      fieldName: "Privacy Policy Link",
      fieldValue: "privacyPolicyLink",
      className: "col-span-6",
      type: "text",
      name: "privacyPolicyLink",
      formType: "input",
      label: "Privacy Policy Link",
      placeholder: "Enter Privacy Policy Link",
      validation: { required: "Privacy Policy Link is required" },
    },
    {
      fieldName: "Play Store Image",
      fieldValue: "playStoreImage",
      className: "col-span-6",
      type: "image",
      usedFileType: "image/*",
      name: "playStoreImage",
      formType: "file",
      label: "Play Store Image",
      placeholder: "Enter Play Store Image",
      validation: { required: "Play Store Image is required" },
    },
    {
      fieldName: "Play Store Link",
      fieldValue: "playStoreLink",
      className: "col-span-6",
      type: "text",
      name: "playStoreLink",
      formType: "input",
      label: "Play Store Link",
      placeholder: "Enter Play Store Link",
      validation: { required: "Play Store Link is required" },
    },
    {
      fieldName: "App Store Image",
      fieldValue: "appStoreImage",
      className: "col-span-6",
      type: "image",
      usedFileType: "image/*",
      name: "appStoreImage",
      formType: "file",
      label: "App Store Image",
      placeholder: "Enter App Store Image",
      validation: { required: "App Store Image is required" },
    },
    {
      fieldName: "App Store Link",
      fieldValue: "appStoreLink",
      className: "col-span-6",
      type: "text",
      name: "appStoreLink",
      formType: "input",
      label: "App Store Link",
      placeholder: "Enter App Store Link",
      validation: { required: "App Store Link is required" },
    },
  ],
  childMenus: [
    {
      fieldName: "Parent Name",
      fieldValue: "parent_name",
      className: "col-span-6",
      type: "text",
      name: "parent_name",
      formType: "select",
      loadOptions: fetchParentData,
      label: "Parent Name",
      placeholder: "Auto-filled from Parent Header",
    },
    {
      fieldName: "Name (EN)",
      fieldValue: "name_en",
      className: "col-span-6",
      type: "text",
      name: "name_en",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "name_ms",
      className: "col-span-6",
      type: "text",
      name: "name_ms",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "name_zh",
      className: "col-span-6",
      type: "text",
      name: "name_zh",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
    },
    {
      fieldName: "Redirect URL",
      fieldValue: "child_redirect_url_en",
      className: "col-span-6",
      type: "text",
      name: "child_redirect_url_en",
      formType: "inputNotes",
      label: "Redirect URL",
      placeholder: "Enter Redirect URL",
      validation: { required: "Redirect URL is required" },
      note: 'Click the info icon to learn more before entering a value.',
      uploadTrigger: true
    },
    // {
    //   fieldName: "Redirect URL (MS)",
    //   fieldValue: "child_redirect_url_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "child_redirect_url_ms",
    //   formType: "input",
    //   label: "Redirect URL (MS)",
    //   placeholder: "Enter Redirect URL (MS)",
    // },
    // {
    //   fieldName: "Redirect URL (ZH)",
    //   fieldValue: "child_redirect_url_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "child_redirect_url_zh",
    //   formType: "input",
    //   label: "Redirect URL (ZH)",
    //   placeholder: "Enter Redirect URL (ZH)",
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Is published",
    },
  ],
  grandChildMenus: [
    {
      fieldName: "Child Header",
      fieldValue: "parent_id",
      className: "col-span-6",
      type: "select",
      name: "parent_id",
      formType: "select",
      loadOptions: fetchChildData,
      label: "Child Header",
      placeholder: "Select Child Header",
      validation: { required: "Child Header is required" },
    },
    {
      fieldName: "Name (EN)",
      fieldValue: "name_en",
      className: "col-span-6",
      type: "text",
      name: "name_en",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "name_ms",
      className: "col-span-6",
      type: "text",
      name: "name_ms",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "name_zh",
      className: "col-span-6",
      type: "text",
      name: "name_zh",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
    },
    {
      fieldName: "Redirect URL",
      fieldValue: "redirect_url_en",
      className: "col-span-6",
      type: "text",
      name: "redirect_url_en",
      formType: "inputNotes",
      label: "Redirect URL",
      placeholder: "Enter Redirect URL",
      validation: { required: "Redirect URL is required" },
      note: 'Click the info icon to learn more before entering a value.',
      uploadTrigger: true
    },
    // {
    //   fieldName: "Redirect URL (MS)",
    //   fieldValue: "redirect_url_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "redirect_url_ms",
    //   formType: "input",
    //   label: "Redirect URL (MS)",
    //   placeholder: "Enter Redirect URL (MS)",
    // },
    // {
    //   fieldName: "Redirect URL (ZH)",
    //   fieldValue: "redirect_url_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "redirect_url_zh",
    //   formType: "input",
    //   label: "Redirect URL (ZH)",
    //   placeholder: "Enter Redirect URL (ZH)",
    // },
    {
      fieldName: "Published",
      fieldValue: "published", // note: keeping the typo as per your data structure
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
    },
  ],
  servicePortals: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "field_footer_logo_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_footer_logo_name_ms",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "field_footer_logo_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_footer_logo_name_zh",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
    },
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      usedFileType: "image/*",
      name: "image",
      formType: "file",
      label: "Image",
      placeholder: "Enter Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Redirect URL",
      fieldValue: "link",
      className: "col-span-6",
      type: "text",
      name: "link",
      formType: "inputNotes",
      label: "Redirect URL",
      placeholder: "Enter Redirect URL",
      validation: { required: "Redirect URL is required" },
      note: 'Click the info icon to learn more before entering a value.',
      uploadTrigger: true
    },
    // {
    //   fieldName: "Redirect URL (MS)",
    //   fieldValue: "redirect_url_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "redirect_url_ms",
    //   formType: "input",
    //   label: "Redirect URL (MS)",
    //   placeholder: "Enter Redirect URL (MS)",
    // },
    // {
    //   fieldName: "Redirect URL (ZH)",
    //   fieldValue: "redirect_url_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "redirect_url_zh",
    //   formType: "input",
    //   label: "Redirect URL (ZH)",
    //   placeholder: "Enter Redirect URL (ZH)",
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
    },
  ],
  socialMedia: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "field_footer_logo_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_footer_logo_name_ms",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "field_footer_logo_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_footer_logo_name_zh",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
    },
    {
      fieldName: "Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      usedFileType: "image/*",
      name: "image",
      formType: "file",
      label: "Image",
      placeholder: "Enter Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Redirect URL",
      fieldValue: "link",
      className: "col-span-6",
      type: "text",
      name: "link",
      formType: "inputNotes",
      label: "Redirect URL",
      placeholder: "Enter Redirect URL",
      validation: { required: "Redirect URL is required" },
      note: 'Click the info icon to learn more before entering a value.',
      uploadTrigger: true
    },
    // {
    //   fieldName: "Redirect URL (MS)",
    //   fieldValue: "redirect_url_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "redirect_url_ms",
    //   formType: "input",
    //   label: "Redirect URL (MS)",
    //   placeholder: "Enter Redirect URL (MS)",
    // },
    // {
    //   fieldName: "Redirect URL (ZH)",
    //   fieldValue: "redirect_url_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "redirect_url_zh",
    //   formType: "input",
    //   label: "Redirect URL (ZH)",
    //   placeholder: "Enter Redirect URL (ZH)",
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
    },
  ],
};
